import React from "react";
import GetStartedBanner from "../../components/ctabanner/GetStartedBanner";
import YellowDivider from "../../components/dividers/YellowDivider";
import CafeCatalogue from "../../components/catalogue/CafeCatalogue";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";

const CafeCataloguePage: React.FC = () => {
  const { t, ready } = useTranslation();
  return (
    <div className="main cafe-page">
      <GetStartedBanner />
      <div className="container mt-4">
				<div className="mb-md-0 mb-lg-3">
					<h2>
						{" "}
						{ready ? (
							`${t("catalogue-filter.cafe-catalogue")}`
						) : (
							<Skeleton width={200} />
						)}
					</h2>
					<YellowDivider heading="h2" />
				</div>
        <CafeCatalogue />
      </div>
    </div>
  );
};

export default CafeCataloguePage;
